import { useGetRenewVisaDocumentList } from "@/api/services/main/renew-visa";
import { IconZoomOut } from "@/assets/icons";
import { Button } from "@/components/elements/Button";
import { Modal } from "@/components/elements/Modal";
import { Pagination } from "@/components/elements/Pagination";
import { Table } from "@/components/elements/Table";
import { DEFAULT_PER_PAGE, START_PAGE } from "@/constants/pagination";
import { TRenewVisaListWithFilter } from "@/features/renew-visa/constants/renewVisaFilter";
import { useRenewVisaSelectionTable } from "@/features/renew-visa/hook/useRenewVisaSelectionTable";
import { usePagination } from "@/hooks/usePagination";
import { useSorting } from "@/hooks/useSorting";
import { useVisible } from "@/hooks/useVisible";
import { divider, text } from "@/theme/colors";
import { TApiSortsReq } from "@/types/api";
import { Box, Stack, styled } from "@mui/material";
import { FC } from "react";

export type TExpandRenewVisaListBtnProps = {
  filter: TRenewVisaListWithFilter;
};

export const ExpandRenewVisaListBtn: FC<TExpandRenewVisaListBtnProps> = ({ filter }) => {
  const expandModal = useVisible();
  const pagReq = usePagination();
  const { sorts } = useSorting();

  const { data: employeeRenewVisaDocumentList, isLoading } = useGetRenewVisaDocumentList({
    page: Number(pagReq.page || START_PAGE),
    perPage: Number(pagReq.perPage || DEFAULT_PER_PAGE),
    sorts: sorts?.length > 0 ? (sorts as TApiSortsReq[]) : filter.sorts,
    status: filter.status,
  });

  const { table, rowSelectionKeys: selectedRenewVisaDocumentIds } = useRenewVisaSelectionTable({
    rows: employeeRenewVisaDocumentList?.data ?? [],
  });

  return (
    <>
      <BoxIcon onClick={() => expandModal.open()}>
        <IconZoomOut fontSize={20} color={text.primary} />
      </BoxIcon>

      <Modal width="95vw" height="80vh" title="在留期間更新の拡大表示" isOpen={expandModal.visible} onClose={expandModal.close} enableFooter={false}>
        <Box pt={3}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
            <Pagination totalPage={employeeRenewVisaDocumentList?.pagination.totalPage} />
            <Button size="sm" disabled={selectedRenewVisaDocumentIds.length === 0}>
              選択した外国人の一括申請を編集
            </Button>
          </Stack>
          <Table table={table} isLoading={isLoading} maxHeight="55vh" />
        </Box>
      </Modal>
    </>
  );
};

const BoxIcon = styled(Box)`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${divider.middle};
  border-radius: 6px;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`;
